import { LawyerConnection, Message, MessageType } from '@law-connect/types';

interface Props {
  connection: LawyerConnection;
  messages: Message[];
}

export const useRequestInfoDisabled = (props: Props) => {
  const { connection, messages } = props;
  if (
    connection?.permissions &&
    connection.permissions.userDetails &&
    connection.permissions.prematterFiles
  ) {
    return true;
  } else {
    const permissionMessages =
      messages?.filter((m) => m.type === MessageType.Permission) ?? [];
    const pending = permissionMessages.find(
      (pm) =>
        pm.from === 'lawyer' &&
        !permissionMessages.find(
          (m) => m?.content?.requestMessageId === pm.id
        )
    );
    return !!pending;
  }
};
